import { BASE_URL } from "../App";

export const makeCSRFRequest = async (url, options = {}) => {
  try {
    // Get CSRF token
    const csrfResponse = await fetch(`${BASE_URL}/csrf-token`, {
      credentials: "include",
    });

    if (!csrfResponse.ok) {
      throw new Error("Failed to get CSRF token");
    }

    const { csrfToken } = await csrfResponse.json();

    // Add CSRF token to headers
    const headers = {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
      ...options.headers,
    };

    return fetch(url, {
      credentials: "include",
      ...options,
      headers,
    });
  } catch (error) {
    console.error("CSRF Request Error:", error);
    throw error;
  }
};
